export default function() {
    console.log('componetn');
}